"use strict";
function isScheduler(value) {
    return value && typeof value.schedule === 'function';
}
exports.isScheduler = isScheduler;
//# sourceMappingURL=isScheduler.js.map


//////////////////
// WEBPACK FOOTER
// /Users/danielcodrea/personal/Projects/HOW-TO_Project/how-to/~/rxjs/util/isScheduler.js
// module id = ../../../../rxjs/util/isScheduler.js
// module chunks = 3